import { render, staticRenderFns } from "./order-dialog.vue?vue&type=template&id=650c7a32&scoped=true"
import script from "./order-dialog.vue?vue&type=script&lang=js"
export * from "./order-dialog.vue?vue&type=script&lang=js"
import style0 from "./order-dialog.vue?vue&type=style&index=0&id=650c7a32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650c7a32",
  null
  
)

export default component.exports